/* eslint-disable */

import env from "../env/env";

export const mockUsers = [
    {
        id: '1',
        name: 'Sarah',
        avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
        hasUnviewedStories: true,
        stories: [
            {
                id: 's1-1',
                imageUrl: `${env.S3_BASE_URL}/Stories/1.png`,
                timestamp: Date.now() - 1800000,
            },
            {
                id: 's1-2',
                imageUrl: `${env.S3_BASE_URL}/Stories/2.png`,
                timestamp: Date.now() - 1800000,
            },
            {
                id: 's1-3',
                imageUrl: `${env.S3_BASE_URL}/Stories/3.png`,
                timestamp: Date.now() - 900000,
            },
            {
                id: 's1-4',
                imageUrl: `${env.S3_BASE_URL}/Stories/4.png`,
                timestamp: Date.now() - 900000,
            },
            {
                id: 's1-5',
                imageUrl: `${env.S3_BASE_URL}/Stories/5.png`,
                timestamp: Date.now() - 900000,
            },
        ],
    },

]
